import type { IconDefinition } from '../index.tsx';

export const iconEmail: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconEmail',
  icon: [
    16,
    16,
    [],
    '',
    'M0 5.3585V14H16V5.35849L8 10.3585L0 5.3585Z M16 3V2H0V3L8 8L16 3Z',
  ],
};
